import { render, staticRenderFns } from "./Airpure.vue?vue&type=template&id=46e937f8&scoped=true&"
import script from "./Airpure.vue?vue&type=script&lang=js&"
export * from "./Airpure.vue?vue&type=script&lang=js&"
import style0 from "./Airpure.vue?vue&type=style&index=0&id=46e937f8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e937f8",
  null
  
)

export default component.exports